import {
  AchIcon,
  AnytimeCalendarIcon,
  ApplePayIcon,
  ArrowRightIcon,
  BlockedIcon,
  CashAppIcon,
  CreditDebitCardIcon,
  CrossIconvector,
  GooglePayIcon,
  GrabPayIcon,
  GreenTickIcon,
  InTransitIcon,
  KlarnaIcon,
  PaymentIcon,
  PaypalIcon,
  RefundedBlueIcon,
  ScheduledIcon,
  SplititIcon,
  SrcIcon,
  SunbitIcon,
  TinkIcon,
  TrueLayerIcon,
  TxnBlockedIcon,
  TxnFailedIcon,
  TxnPendingIcon,
  TxnRefundIcon,
  TxnSuccessIcon,
  TxnTimedOutIcon,
  VenmoIcon
} from 'assets/icons';
import {
  PaymentBlockedIcon,
  PaymentDisputedIcon,
  PaymentFailedIcon,
  PaymentPendingIcon,
  PaymentRefundedIcon,
  PaymentReturnedIcon,
  PaymentSuccessIcon,
  PaymentTimedOutIcon
} from 'assets/icons/invoice-txn-icons';
import { PendingStatusIcon } from 'assets/icons/job-statuses-icon-in-map';
import {
  ACHIcon,
  AffirmIcon,
  AfterpayIcon,
  COFIcon,
  CardStrokeIcon,
  CashappIcon as CashAppIconNew,
  KlarnaIcon as KlarnaIconNew,
  ManualCardEntryIcon,
  ManualCheckIcon,
  ManualOtherIcon,
  ManualPaymentIcon,
  SunbitIcon as SunbitIconNew,
  TTPIcon,
  ZelleIcon
} from 'assets/payment-method-icons';
import { PaymentMethodKeyNameLookup, PaymentMethodKeys, PaymentMethods } from 'constants/common';
import { TransactionStatus, TransactionType } from 'containers/invoices/constants';

export const getPaymentMethodIcons = (paymentMethod: string) => {
  switch (paymentMethod) {
    case PaymentMethods.ACH:
    case PaymentMethods.ACHBETA:
      return <AchIcon />;
    case PaymentMethods.APPLEPAY:
      return <ApplePayIcon />;
    case PaymentMethods.CARD:
      return <CreditDebitCardIcon />;
    case PaymentMethods.GOOGLEPAY:
      return <GooglePayIcon />;
    case PaymentMethods.GRABPAY:
      return <GrabPayIcon />;
    case PaymentMethods.KLARNA:
      return <KlarnaIcon />;
    case PaymentMethods.PAYPAL:
    case PaymentMethods.PAYPAL_SCAN:
      return <PaypalIcon />;
    case PaymentMethods.SPLITIT:
      return <SplititIcon />;
    case PaymentMethods.TINK:
      return <TinkIcon />;
    case PaymentMethods.TRUELAYER:
      return <TrueLayerIcon />;
    case PaymentMethods.VENMO:
    case PaymentMethods.VENMO_SCAN:
      return <VenmoIcon />;
    case PaymentMethods.SGQR:
      return <SrcIcon />;
    case PaymentMethods.CASHAPP:
      return <CashAppIcon />;
    case PaymentMethods.SUNBIT:
      return <SunbitIcon />;
    case PaymentMethods.CLICKTOPAY:
    default:
      return <PaymentIcon />;
  }
};

export const getTxnStatusIcons = (status: string) => {
  switch (status) {
    case TransactionStatus.SUCCESS:
      return <TxnSuccessIcon />;
    case TransactionStatus.PENDING:
    case TransactionStatus.INITIATED:
      return <TxnPendingIcon />;
    case TransactionStatus.BLOCKED:
      return <TxnBlockedIcon />;
    case TransactionStatus.TIMED_OUT:
      return <TxnTimedOutIcon />;
    case TransactionStatus.REFUNDED:
    case TransactionStatus.REFUND_INITIATED:
    case TransactionStatus.REFUND_FAILED:
    case TransactionStatus.REFUND_CANCELLED:
      return <TxnRefundIcon />;
    case TransactionStatus.CANCELLED:
    case TransactionStatus.FAILED:
    case TransactionStatus.VOID:
      return <TxnFailedIcon />;
    case TransactionStatus.IN_TRANSIT:
      return <InTransitIcon />;
    case TransactionStatus.SCHEDULED:
      return <ScheduledIcon />;
    default:
      return <TxnPendingIcon />;
  }
};

export const getNewPaymentMethodIcon = (paymentMethod: string) => {
  switch (paymentMethod) {
    case PaymentMethodKeys.ACH:
    case PaymentMethodKeys.ACHBETA:
      return <ACHIcon />;
    case PaymentMethodKeys.CARD:
    case PaymentMethods.DEBIT_CARD:
    case PaymentMethods.CREDIT_CARD:
    case PaymentMethodKeys.CLICKTOPAY:
    case PaymentMethodKeys.TAP_AND_PAY:
      return <CardStrokeIcon />;
    case PaymentMethodKeys.CARD_ON_FILE:
      return <COFIcon />;
    case PaymentMethodKeys.CASHAPP:
      return <CashAppIconNew />;
    case PaymentMethodKeys.KLARNA:
      return <KlarnaIconNew />;
    case PaymentMethodKeys.SUNBIT:
      return <SunbitIconNew />;
    case PaymentMethodKeys.MANUAL_KEY_IN:
      return <ManualCardEntryIcon />;
    case PaymentMethodKeys.CHECK:
    case PaymentMethodKeys.CHECK_DEPOSIT:
    case PaymentMethodKeys.MOBILE_CHECK_DEPOST:
      return <ManualCheckIcon />;
    case PaymentMethodKeys.CASH:
      return <ManualPaymentIcon />;
    case PaymentMethodKeys.OTHER:
      return <ManualOtherIcon />;
    case PaymentMethodKeys.DIRECTTRANSFER:
      return <ACHIcon />;
    case PaymentMethodKeys.AFFIRM:
      return <AffirmIcon />;
    case PaymentMethodKeys.AFTERPAY:
      return <AfterpayIcon />;
    case PaymentMethods.TTP:
      return <TTPIcon />;
    case PaymentMethodKeys.ZELLE:
      return <ZelleIcon />;
    default:
      return <CardStrokeIcon />;
  }
};

const getStatusBadgeIcon = ({ status, type }: { status: TransactionStatus; type: TransactionType }) => {
  if (type === TransactionType.PAYMENT) {
    switch (status) {
      case TransactionStatus.SUCCESS:
        return PaymentSuccessIcon;
      case TransactionStatus.REFUNDED:
        return PaymentRefundedIcon;
      case TransactionStatus.PENDING:
      case TransactionStatus.INITIATED:
        return PaymentPendingIcon;
      case TransactionStatus.TIMED_OUT:
        return PaymentTimedOutIcon;
      case TransactionStatus.BLOCKED:
        return PaymentBlockedIcon;
      case TransactionStatus.FAILED:
      case TransactionStatus.VOID:
      case TransactionStatus.CANCELLED:
      case TransactionStatus.REFUND_FAILED:
      case TransactionStatus.REFUND_CANCELLED:
        return PaymentFailedIcon;
      default:
        return PaymentSuccessIcon;
    }
  }
  if (type === TransactionType.REFUND) {
    return PaymentRefundedIcon;
  }
  if (type === TransactionType.DISPUTE) {
    return PaymentDisputedIcon;
  }
  if (type === TransactionType.RETURN) {
    return PaymentReturnedIcon;
  }
  return PaymentSuccessIcon;
};

export const getTxnStatusStrokeIcon = ({ status }: { status: TransactionStatus; type?: TransactionType }) => {
  switch (status) {
    case TransactionStatus.SUCCESS:
      return <GreenTickIcon />;
    case TransactionStatus.PENDING:
    case TransactionStatus.INITIATED:
      return <PendingStatusIcon />;
    case TransactionStatus.BLOCKED:
      return <BlockedIcon className="path-fill-current h-4 w-4 text-error" />;
    case TransactionStatus.TIMED_OUT:
      return <PaymentTimedOutIcon />;
    case TransactionStatus.REFUNDED:
    case TransactionStatus.REFUND_INITIATED:
    case TransactionStatus.REFUND_FAILED:
    case TransactionStatus.REFUND_CANCELLED:
      return <RefundedBlueIcon />;
    case TransactionStatus.CANCELLED:
    case TransactionStatus.FAILED:
    case TransactionStatus.VOID:
      return <CrossIconvector className="path-fill-current path text-error" />;
    case TransactionStatus.IN_TRANSIT:
      return <ArrowRightIcon />;
    case TransactionStatus.SCHEDULED:
      return <AnytimeCalendarIcon />;
    default:
      return <GreenTickIcon />;
  }
};

export const getTxnCardIcon = ({
  status,
  type,
  paymentMethod
}: {
  status: TransactionStatus;
  type: TransactionType;
  paymentMethod?: string;
}) => {
  const BadgeIcon = getStatusBadgeIcon({ status, type });

  if (!paymentMethod || paymentMethod === '') {
    return getTxnStatusStrokeIcon({ status, type });
  }

  return (
    <div className="relative flex h-8 w-8 items-center justify-center">
      {getNewPaymentMethodIcon(paymentMethod || '')}
      <div className="absolute bottom-0 right-0">
        <BadgeIcon />
      </div>
    </div>
  );
};

export const getPaymentMethodNameForTxnCard = (paymentMethod: string) => {
  if (!paymentMethod || paymentMethod === '') {
    return '';
  }
  return PaymentMethodKeyNameLookup[paymentMethod] || paymentMethod;
};
